// Changes on "Kiln Color Options" radios and updates selected value.
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function() {
    const radios = document.querySelectorAll('input[name="Kiln Color Options"]');
    if (radios.length) {
      radios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          var selectedRadioButton = document.querySelector('input[name="Kiln Color Options"]:checked');
          if (selectedRadioButton) {
            var selectedValue = selectedRadioButton.value;
            var avpRequiredDiv = document.querySelector('.avp-required');

            if (!avpRequiredDiv) {
              console.log('No element with class "avp-required" found');
              return;
            }

            var existingValueElement = document.querySelector('.avp-selected-color-value');
            if (existingValueElement) {
              existingValueElement.remove();
            }

            var newElement = document.createElement('div');
            newElement.textContent = selectedValue;
            newElement.classList.add('avp-selected-color-value');

            avpRequiredDiv.parentNode.insertBefore(newElement, avpRequiredDiv.nextSibling);
          }
        });
      });
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// When the element with id "short_spec" is clicked, scroll to the specifications tab
const shortSpecsButton = document.getElementById("short_specs");

if (shortSpecsButton) {
  shortSpecsButton.addEventListener("click", function() {
    const specificationsSection = document.querySelector('[data-tab="specifications"]');
    const tabItem = document.querySelector('[data-tab="specifications"]');
    const tabContent = document.querySelector('#specifications');
    
    if (specificationsSection) {
        // specificationsSection.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => { // Adding a slight delay to ensure smooth behavior
            specificationsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    
        const allTabs = document.querySelectorAll('.tab-item');
        allTabs.forEach(function(tab) {
            tab.classList.remove('active');
        });
    
        const allContents = document.querySelectorAll('.tab-content');
        allContents.forEach(function(content) {
            content.classList.remove('active');
        });
        tabItem.classList.add('active');
        tabContent.classList.add('active');
    }
  });
}

$(document).ready(function(){
  //Header menu on hover show submenu js start
  $(".header__inline-menu ul.list-menu.list-menu--inline li").hover(
      function () {
          $(this).find("header-menu").find("details").attr("open", "open"), 
          $(this).find("header-menu").find(".header__submenu").find("details").removeAttr("open");
      },
      function () {
          $(this).find("header-menu").find("details").removeAttr("open");
      }
  ),
  $(".header__inline-menu ul.header__submenu li").hover(
      function () {
          $(this).find("details").attr("open", "open");
      },
      function () {
          $(this).find("details").removeAttr("open");
      }
  );
  //Header menu on hover show submenu js end

  //contact form reset js start
  $(document).on("click", ".custom-contact .contact-reset-btn", function(){
      $(".custom-contact").trigger("reset");
  });
  //contact form reset js end

 // pdp page get kiln part number from url and update in input js start
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  const kilnPartNumber = getQueryParam("kiln-part-number");
  const kilnSerialNumber = getQueryParam("kiln-serial-number");
  function updateInputField() {
    const $inputField = $(".custom-kiln-part-number");
    const $inputSerialField = $(".custom-kiln-serial-number");
    if ($inputField.length && kilnPartNumber || $inputSerialField && kilnSerialNumber) {
      $inputField.val(kilnPartNumber);
      $inputSerialField.val(kilnSerialNumber);
    }
  }
  updateInputField();
  // pdp page get kiln part number from url and update in input js end

  //this is used to remove text from input fields of part and serial number in pdp page start
  // $("#kiln-part-number, #kiln-serial-number").on("input", function () {
  //       $(this).val($(this).val().replace(/\D/g, "")); // Remove non-numeric characters
  //   });
  //this is used to remove text from input fields of part and serial number in pdp page end
  
});

/* Start: Redirect to Product Detail Page (PDP) from Search Results section when Add to Cart is clicked */
document.addEventListener("click", function (e) {
  const btn = e.target.closest('.dfd-cart-add-button button');

  if (btn) {
    const card = btn.closest('.dfd-card');
    const productUrl =
      card?.getAttribute('dfd-value-link') ||
      card?.querySelector('.dfd-card-link')?.href;

    if (productUrl) {
      e.stopImmediatePropagation();
      window.location.href = productUrl;
    }
  }
}, true);
/* End: Redirect to Product Detail Page (PDP) from Search Results section */

/* ============================================
Start: Essential Upsell - Redirect to Product Page
============================================ */
// document.addEventListener(
//   "click",
//   function (e) {
//     const button = e.target.closest(
//       '[data-essential-upsell-element="add-to-cart-button"]'
//     );

//     if (!button) return;

//     e.preventDefault();
//     e.stopPropagation();
//     e.stopImmediatePropagation();

//     const productCard = button.closest(
//       '[data-essential-upsell-element="product"]'
//     );

//     if (!productCard) return;

//     const productLink = productCard.querySelector(
//       '[data-essential-upsell-element="title"]'
//     );

//     if (productLink && productLink.href) {
//       window.location.href = productLink.href;
//     }
//   },
//   true
// );
/* ============================================
End: Essential Upsell - Redirect to Product Page
============================================ */